import { Box } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import classNames from "classnames";
import _ from "lodash";
import { compose } from "ramda";
import { ChangeEvent, memo, useState } from "react";
import { useDispatch } from "react-redux";

import { Toast } from "../../Errors/Toast";
import { CommonFormElProps } from "../../types";
import { withImageUploader, withImagePreview, ImagePreviewProps } from "../HOC";
import styles from "../ImageUploader.module.scss";
import { setImage } from "../images.slice";
import { SelectFileAction } from "../types";
import { ImageProperties } from "../utilities/FilesProperties";
import { imageTypes, localStorageNames } from "../utilities/enums";
import { ListOfFiles } from "../utilities/localStorageManagement";

export type SingleImageUploaderProps = {
  readonly allowedExtensions: string;
  readonly onSelectFile: SelectFileAction;
} & Pick<CommonFormElProps, "id" | "isComplex" | "label"> &
  ImagePreviewProps;

export const ImageUploader = memo<SingleImageUploaderProps>(
  ({ allowedExtensions, onSelectFile, imageId, imageSectionId }) => {
    const [errorMessage, setErrorMessage] = useState("");
    const dispatch = useDispatch();
    const setFile = (uploadedFile: File) => {
      /* LPPLWEBMOB-454 */
      const fileslist = ListOfFiles.GetListOfFiles();
      const ifpdf = uploadedFile.name.includes(".pdf") ? "true" : "false";
      if (imageId == "frontImage") {
        ListOfFiles.frontImage.ifFileIsPdf = ifpdf == "true";
        ImageProperties.imageType = imageTypes.front;
      } else {
        ListOfFiles.backImage.ifFileIsPdf = ifpdf == "true";
        ImageProperties.imageType = imageTypes.back;
      }
      dispatch(
        setImage({ section: imageSectionId, type: imageId, src: uploadedFile })
      );
    };

    const getIllegalSigns = (name: string) => {
      const illegalSignsList = /[&<>/;*"'\\]/g;
      return [...new Set(name.match(illegalSignsList))];
    };

    const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
      const maxPdfSize = 5 * 1024 * 1024;
      const file = onSelectFile(e.target.files);

      if (file.length === 0) {
        return;
      }
      if (
        file[0].type === "application/pdf" &&
        !_.isEmpty(getIllegalSigns(file[0].name))
      ) {
        setErrorMessage("Nazwa załączonego pliku zawiera niedozwolone znaki");
      } else if (
        file[0].type === "application/pdf" &&
        file[0].size > maxPdfSize
      ) {
        setErrorMessage(
          "Załączono za duży plik, limit wielkości plików PDF wynosi 5MB"
        );
      } else {
        setFile(file[0]);
      }
    };

    const handleToastClose = () => {
      setErrorMessage("");
    };

    return (
      <>
        <Toast
          isVisible={!_.isEmpty(errorMessage)}
          handleClose={handleToastClose}
          message={errorMessage}
        />
        <Box className={classNames(styles.selectImage, styles.wrapper)}>
          <Box>
            <AddIcon fontSize="large" />
          </Box>
          <input
            accept={allowedExtensions}
            type="file"
            onChange={handleOnChange}
            placeholder="prześlij zdjęcie"
          />
        </Box>
      </>
    );
  }
);

export const SingleImageUploader = compose(
  withImagePreview,
  withImageUploader
)(ImageUploader);
